import { withStyles, TableRow } from '@material-ui/core'

const StyledTableRow = withStyles({
  root: {
    border: '1px solid #dadada',
    fontSize: 14,
    fontFamily: 'Open Sans',
    backgroundColor: '#fff'
  }
})(TableRow)

export default StyledTableRow